import { identify, setGlobalContext, track } from '@helpers/gainsight.helpers';

export const gainsight = {
  identify,
  track,
  setGlobalContext,
};
